import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuthStore } from '../store/auth';
import type { AuthTokens } from '@marnic/shared';

export function Login(): JSX.Element {
  const [email, setEmail] = useState('admin@marnic.local');
  const [password, setPassword] = useState('admin123');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = getSafeRedirect(
    (location.state as { from?: unknown } | null)?.from
      ?? sessionStorage.getItem('marnic.postLoginRedirect'),
  );

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await api.post<AuthTokens>('/auth/login', { email, password });
      setSession(result);
      sessionStorage.removeItem('marnic.postLoginRedirect');
      navigate(redirectTo, { replace: true });
    } catch (err: unknown) {
      const code = (err as { code?: string }).code;
      setError(code === 'INVALID_CREDENTIALS' ? 'Invalid email or password' : 'Sign-in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-100 p-6">
      <form onSubmit={submit} className="card w-full max-w-sm p-6 space-y-4">
        <div>
          <h1 className="text-xl font-semibold">Marnic Dialler</h1>
          <p className="text-sm text-ink-500">Sign in to your workspace</p>
        </div>
        <div>
          <label className="label">Email</label>
          <input
            type="email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
        </div>
        <div>
          <label className="label">Password</label>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="text-xs text-ink-500">
          Default seeded credentials for dev: <code>admin@marnic.local</code> / <code>admin123</code>.
        </p>
      </form>
    </div>
  );
}

function getSafeRedirect(from: unknown): string {
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//')) {
    return '/';
  }
  return from;
}
